<template>
  <div class="container">
    <!-- 面包屑 -->
    <div class="brand">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ brandName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 信息框 -->
    <div class="info">
      <el-row>
        <el-col :span='4'>
          <div class="txt">{{ title }}</div>
        </el-col>
        <el-col :span='20'>
          <div class="tip">{{ behaviour == 1 ? '行为收集' : '问卷测试' }}</div>
        </el-col>
      </el-row>
      <div class="mes">
        <el-row>
          <el-col :span='4'><div><span>发布时间：</span><span>{{ publishTime }}</span></div></el-col>
          <el-col :span='4'><div><span>到期时间：</span><span>{{ expireTime }}</span></div></el-col>
          <el-col :span='4'><div><span>创建时间：</span><span>{{ createTime }}</span></div></el-col>
          <el-col :span='4'><div><span>创建者：</span><span>{{ createUser }}</span></div></el-col>
        </el-row>
      </div>


    </div>

    <!-- 菜单栏 -->
    <div class="menu">
      <el-row>
        <el-col :span='2'>
          <router-link to="/data/meta">
            <div v-bind:class="{'active':current == 1}" class="box" @click="changeCurrent(1)"><span>元数据</span></div>
          </router-link>
        </el-col>
        <el-col :span='2'>
          <router-link to='/data/join'>
            <div v-bind:class="{'active':current == 2}" class="box" @click="changeCurrent(2)"><span>参与者</span></div>
          </router-link>
        </el-col>
        <el-col :span='2'>
          <router-link to='/data/information'>
            <div v-bind:class="{'active':current == 3}" class="box" @click="changeCurrent(3)"><span>数据</span></div>
          </router-link>
        </el-col>
        <el-col :span='2'>
          <router-link to='/data/message'>
            <div v-bind:class="{'active':current == 4}" class="box" @click="changeCurrent(4)"><span>消息</span></div>
          </router-link>
        </el-col>
        <el-col :span='2'>
          <router-link to='/data/dashboard'>
            <div v-bind:class="{'active':current == 5}" class="box" @click="changeCurrent(5)"><span>仪表盘</span></div>
          </router-link>
        </el-col>
      </el-row>
    </div>

    <!-- 出口 -->
    <div>
      <router-view></router-view>
    </div>

  </div>
</template>

<script>
import metaData from '../data/metaData'
import join from '../data/join'
import information from '../data/data'
import dashboard from '../data/dashboard'
import message from '../data/message'
export default {
  components: { metaData, join, information, dashboard, message},
  data () {
    return {
      title: '',   // 实验名称
      behaviour: 1, // 行为采集
      publishTime: '',  // 开始时间
      expireTime: '',  //结束时间
      createTime: '',
      createUser: 'admin',  // 创建者
      current: 1,
      projectId: '',
      brandName: '',
    }
  },

  created () {
    if (this.$route.query.current) {
      this.current = this.$route.query.current
    } else {
      this.current = this.$store.state.dataCurrent
    }
    if (this.current == 1) {
        this.brandName = '元数据'
      } else if (this.current == 2) {
        this.brandName = '参与者'
      } else if (this.current == 3) {
        this.brandName = '数据'
      } else if (this.current == 4) {
        this.brandName = '消息'
      } else if (this.current == 5) {
        this.brandName = '仪表盘'
      }
    if (this.$route.query.id) {
      this.projectId = +this.$route.query.id
    } else {
      this.projectId = +this.$store.state.projectId
    }
    this.getTitle()
  },

  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      handler: function(val, oldVal){
        if (this.$route.name == 'Information') {
          this.current = 3
          this.brandName = '数据'
        } else if ( this.$route.name == 'metaData' ) {
          this.current = 1
          this.brandName = '元数据'
        } else if ( this.$route.name == 'Join' ) {
          this.current = 2
          this.brandName = '参与者'
        } else if ( this.$route.name == 'Dashboard' ) {
          this.current = 5
          this.brandName = '仪表盘'
        } else if ( this.$route.name == 'dataDetail' ) {
          this.current = 3
          this.brandName = '数据'
        } else if (this.$route.name == 'Message') {
          this.current = 4
          this.brandName = '消息'
        }
      },
      // 深度观察监听
      deep: true
    }
  },

  methods: {
    // 切换菜单
    changeCurrent (cur) {
      this.current = cur
      this.$store.commit('getCurrent', {
        dataCurrent: cur
      })
      if (cur == 1) {
        this.brandName = '元数据'
      } else if (cur == 2) {
        this.brandName = '参与者'
      } else if (cur == 3) {
        this.brandName = '数据'
      } else if (cur == 4) {
        this.brandName = '消息'
      } else if (cur == 5) {
        this.brandName = '仪表盘'
      }
    },

    // 获取页头信息
    getTitle () {
      this.httpPost('/web/project/v1/searchProjectList',{
        endTime: null,
        keywords: null,
        pageNum: null,
        pageSize: null,
        startTime: null,
        status:null
      }).then((res) => {
        if (res.code == 0) {
          res.data.data.forEach(item => {
            if (this.projectId == item.id) {
              this.title = item.title
              this.createTime = item.createTime
              this.createUser = item.createUserName
              this.expireTime = item.expireTime
              this.publishTime = item.publishTime
            }
          })
        } else if (res.code == 10001 || res.code == 10002) {
          this.$message({
            type: 'error',
            message: res.message
          })
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .info{
    width: 100%;
    padding: 20px;
    background-color: #fbfbfb;
    border: 1px solid #e1e1e1;
    .txt{
      color: #444;
      font-weight: 700;
      line-height: 25px;
    }
    .tip{
      width: 70px;
      font-size: 13px;
      height: 25px;
      line-height: 25px;
      background: #8bc34a;
      color: #fff;
      border-radius: 5px;
      text-align: center;
    }
    .mes{
      margin-top: 15px;
      span{
        font-size: 13px;
        color: #555;
      }
    }
  }
  .menu{
    width: 100%;
    margin: 30px 0;
    .box{
      width: 80px;
      height: 30px;
      line-height: 28px;
      text-align: center;
      border: 1px solid #ccc;
      background-color: #eee;
      cursor: pointer;
      color: #333;
    }
    .active{
      background-color: #cc061e;
      color: #fff;
      border: 1px solid #cc061e;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/data/dataIndex.vue